export default {
  path: '/main/wechatMgmt/customerStatisticsInternal',
  name: 'CustomerStatisticsInternal',
  component: () =>
    import(
      '@/views/main/wechatMgmt/customerStatisticsInternal/CustomerStatisticsInternal.vue'
    )
}
